//// rishabh code with delete
import {
  Button,
  ContextMenu,
  SelectBox,
  LoadPanel,
  TextBox,
} from "devextreme-react";
import DataGrid, {
  Column,
  Export,
  Pager,
  Paging,
  Scrolling,
  SearchPanel,
  Selection,
  Toolbar,
} from "devextreme-react/data-grid";
import { Item } from "devextreme-react/toolbar";
import React, { useRef, useState, useEffect } from "react";
import BreadCrumb from "../../components/breadCrumb/BreadCrumb";
import CustomPageHeader from "../../components/customPageHeader/CustomPageHeader";
import { SubText } from "../../components/typographyText/TypographyText";
import { useNavigate } from "react-router-dom";
import { confirm } from "devextreme/ui/dialog";
import "./UsersPage.scss";
import { custPwdDataSource } from "../customers/data";
import { fetchUsers, user_delete } from "../../api/companyUserApi";
import { ToastDisplayer } from "../../components/toastDisplay/ToastDisplayer";
import { custStatusDataSource } from "../customers/data";
import { useAuth } from "../../contexts/auth";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { exportDataGrid } from "devextreme/excel_exporter";

export default function UsersPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const userdataGridRef = useRef(null);
  const [statusFilter, setStatusFilter] = useState("All");
  const [passwordFilter, setPasswordFilter] = useState("All");
  const [usersDataSource, setUsersDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  var selectedRowData = "";
  const [displayedTicketCount, setDisplayedTicketCount] = useState(0);

  const updateDisplayedTicketCount = () => {
    if (userdataGridRef.current?.instance) {
      const totalCount = userdataGridRef.current.instance.totalCount();
      setDisplayedTicketCount(totalCount || 0);
    }
  };

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        const res = await fetchUsers(user?.companytransid);
        if (!res || !res.data || res.data.length === 0) {
          // ToastDisplayer("error", "Data not found");
          return;
        } else {
          // ToastDisplayer("success", "Data Displayed Successfully");
        }
        const modifiedData = res.data.map((user) => ({
          ...user,
          cmpuserstatus: user.cmpuserstatus === "active" ? "A" : "I",

          // Convert roles array to comma separated string
          // rolesDisplay:
          //   user.role_details && user.role_details.length > 0
          //     ? user.role_details.map((role) => role.rolename).join(", ")
          //     : "-",

          projectsDisplay:
            user.project_details && user.project_details.length > 0
              ? user.project_details
                  .map((project) => project.ticketsubcatname)
                  .join(", ")
              : "-",

          descriptionDisplay: user.project_details || [],
        }));
        setUsersDataSource(modifiedData);
      } catch (err) {
        ToastDisplayer(
          "error",
          err.response?.data?.error || err.response.config.data,
        );
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, []);

  const handleStatusFilterChange = (newFilter) => {
    setStatusFilter(newFilter);
    const filterValue = newFilter === "All" ? undefined : newFilter;
    if (userdataGridRef.current && userdataGridRef.current.instance) {
      userdataGridRef.current.instance.columnOption(
        "STATUS",
        "filterValue",
        filterValue,
      );
      userdataGridRef.current.instance.refresh();
    }
  };

  const handlePwdFilterChange = (newFilter) => {
    setPasswordFilter(newFilter);
    const filterValue = newFilter === "All" ? null : newFilter;

    if (userdataGridRef.current && userdataGridRef.current.instance) {
      userdataGridRef.current.instance.columnOption(
        "PASSWORD REQUEST",
        "filterValue",
        filterValue,
      );
      userdataGridRef.current.instance.refresh();
    }
  };

  const getStatusColor = (status) => {
    const statusColors = {
      Active: "#0C6230",
      Inactive: "#910000",
    };
    return statusColors[status];
  };

  const onCloneIconClick = (e) => {
    selectedRowData = e.data;
  };

  const handleDeleteUser = async (uCode) => {
    setLoading(true);

    try {
      const result = await user_delete(uCode);

      if (result) {
        setUsersDataSource((prevData) =>
          prevData.filter((item) => item.cmpusercode !== uCode),
        );

        ToastDisplayer(
          "success",
          result?.data?.message || "User deleted successfully!",
        );
      } else {
        ToastDisplayer(
          "error",
          result?.data?.error ||
            result?.data?.message ||
            "Failed to delete user.",
        );
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "An error occurred during User deletion.",
      );
    } finally {
      setLoading(false);
    }
  };
  const handleDelete = (uCode) => {
    confirm("Are you sure you want to delete this record?").then((result) => {
      if (result) {
        // setUsersDataSource((prevData) =>
        //   prevData.filter((item) => item.cmpusercode !== uCode),
        // );
        handleDeleteUser(uCode);
      }
    });
  };

  const actionTemplate = (cellData) => {
    const actionMenuItems = [
      {
        icon: "ri-archive-drawer-fill",
        text: "Assign Project",
        onClick: () => {
          navigate("/Developer/Assign-Projects", {
            state: { userdata: cellData.data },
          });
        },
      },
      {
        icon: "ri-pencil-fill",
        text: "Edit & View",
        onClick: () => {
          navigate("/Developer/Edit-Developer", {
            state: cellData.data,
          });
        },
      },
      {
        icon: "ri-delete-bin-fill",
        text: "Delete",
        onClick: () => {
          handleDelete(cellData.data["cmpusercode"]);
        },
      },
    ];

    const sanitizeClassName = (str) => {
      return String(str).replace(/[^a-zA-Z0-9_-]/g, "");
    };

    const sanitizedClassName = `actionbtn-${sanitizeClassName(cellData.data.cmpusercode)}`;

    const renderItem = (item) => (
      <div className="action-icon">
        <i className={item.icon}></i>
        <span className="action-text">{item.text}</span>
      </div>
    );

    return (
      <>
        <div className="nextPageBtn">
          <div
            className={sanitizedClassName}
            onClick={() => onCloneIconClick(cellData)}
          >
            <i className="ri-more-fill"></i>
          </div>
        </div>
        <ContextMenu
          items={actionMenuItems}
          target={`.${sanitizedClassName}`}
          showEvent="dxclick"
          cssClass="actionMenu"
          itemRender={renderItem}
        />
      </>
    );
  };

  const handleCreateNew = () => {
    navigate("/Developer/Add-Developer");
  };

  //Function to mask the phone number :
  const maskPhoneNumber = (phone) => {
    if (!phone) return "";

    const visiblePart = phone.slice(0, 4);
    const maskedPart = "X".repeat(phone.length - 4);

    return visiblePart + maskedPart;
  };

  // export functionality for custom  Export Button
  const handleExport = () => {
    const grid = userdataGridRef.current?.instance;
    if (!grid) return;

    const selectedKeys = grid.getSelectedRowKeys();

    if (selectedKeys.length > 0) {
      grid.exportToExcel(true); // selected rows
    } else {
      grid.exportToExcel(false); // fallback → all rows
    }
  };
  const onExporting = (e) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Tickets");

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      const now = new Date();

      const formattedDate = `${now.getFullYear()}-${String(
        now.getMonth() + 1,
      ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

      const fileName = `Agents_${formattedDate}.xlsx`; // ✅ dynamic name

      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          fileName,
        );
      });
    });

    e.cancel = true; // ❗ VERY IMPORTANT (stops default export)
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <div className="wholePage">
        <div className="headerComponent">
          <div className="headerContainer1">
            <div className="title">
              <span class="icon-size">
                <i class="ri-user-settings-line"></i>
              </span>
              <p>All Developer</p>
            </div>
            {/* <div className="totalTicketTitle">
              <SubText
                text={`In total, you have ${displayedTicketCount} developers`}
              />
            </div> */}
          </div>
          <div className="headerContainer2">
            <Button
              text="Export"
              icon="export"
              stylingMode="outlined"
              type="default"
              width={120}
              onClick={handleExport}
            />
            <Button
              className="addBtn"
              text="Add Developer"
              icon="add"
              stylingMode="outlined"
              type="default"
              width={160}
              onClick={handleCreateNew}
            />
          </div>
        </div>

        {/* <CustomPageHeader
          // titleName={"Developer"}
          handleCreateNew={handleCreateNew}
          btnText={"Add New"}
        /> */}
        <div className="datagridContainer">
          <div className="mainDatagrid middlePart">
            <DataGrid
              width={"100%"}
              height={"100%"}
              className={"custGrid"}
              dataSource={{
                store: usersDataSource,
                sort: [{ selector: "cmpusercode", desc: true }], // descending order
              }}
              ref={userdataGridRef}
              allowColumnReordering={true}
              rowAlternationEnabled={false}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              showColumnHeaders={true}
              onContentReady={updateDisplayedTicketCount}
              onExporting={onExporting}
            >
              <Export enabled={true} />
              <Toolbar>
                <Item location="before">
                  <div style={{ fontWeight: "600", fontSize: "18px" }}>
                    <SubText
                      text={`Total ${displayedTicketCount} Developers`}
                    />
                  </div>
                </Item>
                <Item name="searchPanel" />
                <Item location="after">
                  <SelectBox
                    width={150}
                    height={44}
                    id="filterStatus"
                    valueExpr="value"
                    displayExpr="text"
                    stylingMode="outlined"
                    className="selectboxStatus"
                    placeholder="All Status"
                    items={custStatusDataSource}
                    value={statusFilter}
                    onValueChanged={(e) => handleStatusFilterChange(e.value)}
                  />
                </Item>
                {/* <Item location="after">
                <SelectBox
                  width={"200px"}
                  value={passwordFilter}
                  height="44px"
                  className="selectboxStatus"
                  valueExpr="value"
                  displayExpr="text"
                  stylingMode="outlined"
                  items={custPwdDataSource}
                  onValueChanged={(e) => handlePwdFilterChange(e.value)}
                />
              </Item> */}
              </Toolbar>
              <SearchPanel visible={true} width={200} placeholder="Search" />
              <Selection mode="multiple" showCheckBoxesMode="always" />
              <Pager
                visible={true}
                // allowedPageSizes={[10, 20, 30]}
                // showPageSizeSelector={true}
              />
              <Paging defaultPageSize={10} />
              <Scrolling mode="virtual" />
              <Column
                width={220}
                alignment="left"
                dataField="cmpuserusername"
                caption="USER NAME"
              />
              {/* <Column dataField="rolesDisplay" caption="ROLES" /> */}
              <Column
                width={100}
                alignment="center"
                allowSorting={false}
                allowSearch={false}
                cellRender={(cellData) => actionTemplate(cellData)}
              />
              <Column
                width={100}
                dataField="cmpuserstatus"
                caption="STATUS"
                cellRender={(data) => {
                  const value = data.value === "A" ? "Active" : "Inactive";
                  return (
                    <>
                      <span className="col-main2" data-type={value}>
                        <span
                          className="cust-status-circle"
                          style={{
                            backgroundColor: getStatusColor(value),
                          }}
                        />
                        <span
                          data-type={value}
                          style={{
                            color: getStatusColor(value),
                            fontWeight: "500",
                          }}
                        >
                          {value}
                        </span>
                      </span>
                    </>
                  );
                }}
              />
              {/* <Column
              dataField="isotpverified"
              caption="OTP VERIFICATION"
              cellRender={(data) => {
                const value = data.value ? "Yes" : "No";
                return <span>{value}</span>;
              }}
            /> */}
              <Column
                dataField="cmpusercode"
                caption="USER CODE"
                width={150}
                alignment="center"
              />
              <Column
                width={180}
                alignment="center"
                dataField="isotpverified"
                caption="OTP VERIFIED"
                calculateCellValue={(row) =>
                  String(row.isotpverified).toUpperCase() === "Y" ? "Yes" : "No"
                }
              />
              <Column dataField="cmpuseremail" caption="EMAIL ID" width={370} />
              {/* <Column
              hidingPriority={1}
              dataField="passwordreq"
              caption="PASSWORD REQUEST"
              cellRender={(data) => {
                let passwordRequest;
                if (data?.data?.passwordreq == null) {
                  passwordRequest = "-";
                } else if (data.data.passwordreq === "pending") {
                  passwordRequest = "Pending";
                } else {
                  passwordRequest = "Changed";
                }
                return (
                  <span className="col-main" data-type={passwordRequest}>
                    <span data-type={passwordRequest}>{passwordRequest}</span>
                  </span>
                );
              }}
            /> */}
              <Column
                width={199}
                dataField="cmpusercontactnumber"
                caption="CONTACT NUMBER"
                cellRender={(data) =>
                  maskPhoneNumber(data?.data?.cmpusercontactnumber)
                }
              />
              {/* <Column
              dataField={"entry_date"}
              defaultSortOrder="desc"
              visible={false}
            /> */}
              <Column
                width={400}
                dataField="projectsDisplay"
                caption="PROJECTS"
                cellRender={(data) => {
                  if (!data?.value) return <span>-</span>;
                  return (
                    <div title={data.value} className="truncate-cell">
                      {data?.value}
                    </div>
                  );
                }}
              />
              {/* <Column
                caption="PROJECT DESCRIPTION"
                dataField="descriptionDisplay"
                hidingPriority={0}
                cellRender={(data) => {
                  const projects = data.value;

                  if (!projects || projects.length === 0) {
                    return <span>-</span>;
                  }

                  return (
                    <div className="project-description-wrapper">
                      {projects.map((p, index) => (
                        <div key={index} className="project-item">
                          <strong>{p.ticketsubcatname}</strong>
                          <div>{p.description}</div>
                        </div>
                      ))}
                    </div>
                  );
                }}
              />{" "} */}
            </DataGrid>
          </div>
        </div>
      </div>
    </>
  );
}
